// import React from "react";
// import styled from "styled-components";
// import careerVideo from "../../../assets/images/career/careervideo.mp4"; // Import your video file

// // Styled Components
// const Section = styled.section`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   padding: 0.5em;
//   min-height: 100vh;
//   background-color: #f8f9fa;
//    font-family: "Poppins", sans-serif;

//   @media (min-width: 768px) {
//     flex-direction: row;
//     justify-content: space-between;
//     padding:4rem 4rem 5rem 7rem;
//   }
// `;

// const Content = styled.div`
//   max-width: 600px;
//   margin: 1rem;

//   @media (min-width: 768px) {
//     margin-right: 2rem;
//   }
// `;

// const Badge = styled.span`
//   display: inline-block;
//   background-color: #e0e0e0;
//   color: #333;
//   border-radius: 12px;
//   padding: 0.5rem 1rem;
//   font-weight: bold;
//   margin-bottom: 1rem;
//   font-size: 0.875rem;
// `;

// const Title = styled.h1`
//   font-size: 2rem;
//   color: #333;
//   margin: 0.5rem 0;
//   font-weight:500;
 


//   @media (min-width: 768px) {
//     font-size: 2.5rem;
//   }
// `;

// const Subtitle = styled.h2`
//   font-size: 2.5rem;
//   font-weight: bold;
//   color: #07b6f2;
//   margin: 0.5rem 0;
//   line-height: 1.35;

//   @media (min-width: 768px) {
//     font-size: 3rem;
//   }
// `;

// const Text = styled.p`
//   font-size: 1em;
//   color: #777777;
//   margin-top: 1rem;
//   text-align: justify;
//   line-height: 2;

//   @media (min-width: 768px) {
//     font-size: 1em;
//   }
// `;

// const Video = styled.video`
//   max-width: 100%;
//   height: auto;

//   border-radius: 11px;
//   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
//   object-fit: cover; /* Crops the video */
//   object-position: top; /* Crops from the top */
  
//   @media (min-width: 768px) {
//     max-width: 50%;
//     margin-top: 0;
//   }
// `;

// // Main Component
// const CareerSection = () => {
//   return (
//     <Section>
//       <Content>
//         <Badge>Career</Badge>
//         <Title>Make Your</Title>
//         <Subtitle>Career Vision Your Life Reality!</Subtitle>
//         <Text>
//           NexTech welcomes both freshers and experienced professionals,
//           especially in Teamcenter. Our culture promotes learning, ownership,
//           and excellence. Join us to work globally with diverse colleagues and
//           clients. If this resonates with you, apply to the positions below or
//           send us your resume.
//         </Text>
//       </Content>
//       <Video autoPlay muted loop>
//         <source src={careerVideo} type="video/mp4" />
//         Your browser does not support the video tag.
//       </Video>
//     </Section>
//   );
// };

// export default CareerSection;
import React from 'react';
import styled, { keyframes } from 'styled-components';
import careerVideo from '../../../assets/images/career/careervideo.mp4';

const slideInLeft = keyframes`
  from { opacity: 0; transform: translateX(-40px); }
  to   { opacity: 1; transform: translateX(0); }
`;

const slideInRight = keyframes`
  from { opacity: 0; transform: translateX(40px); }
  to   { opacity: 1; transform: translateX(0); }
`;

const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 1.25rem 4rem;
  min-height: 100vh;
  background-color: #f9fafb;
  font-family: 'Poppins', sans-serif;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    padding: 4rem 4rem 5rem 7rem;
  }
`;

const Content = styled.div`
  max-width: 600px;
  margin: 1rem;
  animation: ${slideInLeft} 0.7s ease-out;

  @media (min-width: 768px) {
    margin-right: 2rem;
  }
`;

const Badge = styled.span`
  display: inline-block;
  background-color: #e5e7eb;
  color: #374151;
  border-radius: 999px;
  padding: 0.45rem 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  font-size: 0.82rem;
  letter-spacing: 0.09em;
  text-transform: uppercase;
`;

const Title = styled.h1`
  font-size: 2.1rem;
  color: #111827;
  margin: 0.4rem 0;
  font-weight: 500;

  @media (min-width: 768px) {
    font-size: 2.4rem;
  }
`;

const Subtitle = styled.h2`
  font-size: 2.6rem;
  font-weight: 700;
  color: #07b6f2;
  margin: 0.5rem 0;
  line-height: 1.3;

  @media (min-width: 768px) {
    font-size: 3rem;
  }
`;

const Text = styled.p`
  font-size: 0.98rem;
  color: #6b7280;
  margin-top: 1rem;
  text-align: justify;
  line-height: 1.9;
`;

const Video = styled.video`
  max-width: 100%;
  height: auto;
  border-radius: 14px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.35);
  object-fit: cover;
  object-position: top;
  margin-top: 1.5rem;
  animation: ${slideInRight} 0.7s ease-out;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  @media (min-width: 768px) {
    max-width: 50%;
    margin-top: 0;
  }

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.45);
  }
`;

const CareerSection = () => {
  return (
    <Section>
      <Content>
        <Badge>Career</Badge>
        <Title>Make Your</Title>
        <Subtitle>Career Vision Your Life Reality!</Subtitle>
        <Text>
          NexTech welcomes both freshers and experienced professionals, especially in Teamcenter.
          Our culture promotes learning, ownership, and excellence. Join us to work globally with
          diverse colleagues and clients. If this resonates with you, apply to the positions below
          or send us your resume.
        </Text>
      </Content>
      <Video autoPlay muted loop playsInline>
        <source src={careerVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </Video>
    </Section>
  );
};

export default CareerSection;
